<template>
    <!--酒店报价列表-->
    <div class="hotel-quotation" v-if="quotationList">
        <div class="hotel-quotation-head">
            <div class="OrderHousing-title" v-if="quotationList.count>0">已有<span class="text-primary"> {{quotationList.count}} </span>家酒店报价</div>
            <div class="OrderHousing-title" v-else>酒店报价</div>
            <div class="sort" v-if="quotationList.count>0">
                <p>排序</p>
                <el-select v-model="sort" placeholder="请选择" @change="combineTay">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <div class="hotel-map" @click="goForDetail"><i class="el-icon-location-information mr-1"></i>查看地图</div>
            </div>
        </div>
        <!--报价标题-->
        <!-- <ul class="hotel-quotation-title">
            <li v-for="(item,index) in hotelQuotationTitle" :key="index" :style="{width:item.width}">
                {{item.title}}
            </li>
        </ul> -->
        <!--报价列表-->
        <template v-if="quotationList.count>0">
            <el-table
                class="hotel-quotation-list"
                :data="hotelList"
                :header-cell-style="{background:'#f2f7fe'}"
                border
                style="width: 100%">
                <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" >
                <!-- 自定义表头 -->
                    <template slot-scope="scope">
                            <!--酒店信息-->
                            <div  class="hotel-title" v-if="item.pattern==='title'">
                                <img v-lazy="$GFUN.formatImgSrc(scope.row['hotel_top_pic'],64,64)" class="hotel-img"/>
                                <div class="hotel-title-content">
                                    <div class="title">
                                        {{ scope.row[item.prop]}}
                                        <img v-lazy="'/images/zfxj/icon_'+scope.row['hotel_state_star']+'.png'" :key="scope.row['hotel_state_star']" height="18px" v-if="scope.row['hotel_state_star']>0"/>
                                        <img v-lazy="'/images/xj/icon_'+scope.row['hotel_star']+'.png'" :key="scope.row['hotel_star']" height="18px" v-else/>
                                    </div>
                                    <div class="star">{{ scope.row['hotel_star']| formatVar('HotelStar')}}</div>
                                </div>
                            </div>
                            <!--时间-->
                            <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                            <!--金额-->
                            <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">{{ scope.row[item.prop]/100 | formatMoney}}<div class="price_pay" v-if="item.prop=='price_pay'&&scope.row.broker==1">(代订收款)</div></div>
                            <!--用房报价-->
                            <div  class="room_offer_arr" :class="{'text-center':item.center}" v-else-if="item.pattern==='room_offer_arr'">
                                <!--接不了状态-->
                                <template v-if="!scope.row.meeting_offer_arr.list&&!scope.row.room_offer_arr.list">
                                    <div class="canAnswer">
                                        酒店回复:接不了、原因：{{ scope.row.offer_remark}}
                                    </div>
                                </template>
                                <!--报价状态-->
                                <template v-else>
                                    <!--旧版用房报价-->
                                    <el-table
                                        :data="scope.row[item.prop].list"
                                        border
                                        size="mini"
                                        style="width:100%"
                                        :header-cell-style="{background:'#f5f7fa'}"
                                        max-height="180"
                                        class="mb-2"
                                        v-if="scope.row.room_offer_arr.list&&scope.row.room_offer_arr.mode==0"
                                    >
    
                                        <el-table-column label="名称"  align="center">
                                            <template slot-scope="scope">
                                                <div  class="cursor-pointer" :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')">
                                                {{scope.row.offer_title}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="价格"  align="center">
                                            <template slot-scope="scope">
                                                {{scope.row.offer_price}}元/间
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--新版用房报价-->
                                    <el-table
                                        :data="flatOfferTable(scope.row[item.prop])"
                                        border
                                        size="mini"
                                        :span-method="objectSpanMethod"
                                        style="width:100%"
                                        :header-cell-style="{background:'#f5f7fa'}"
                                        max-height="180"
                                        class="mb-2"
                                        v-else-if="scope.row.room_offer_arr.list"
                                    >
                                        <el-table-column label="时间"  align="center">
                                            <template slot-scope="scope">
                                                {{scope.row.date| formatTimestamp(2)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="名称"  align="center">
                                            <template slot-scope="scope">
                                                <div  class="cursor-pointer" :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')">
                                                    {{scope.row.offer_title}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="价格"  align="center">
                                            <template slot-scope="scope">
                                                {{scope.row.offer_price}}元/间
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--会议室报价-->
                                    <div class="meeting" :class="{'text-center':item.center}" v-if="scope.row.meeting_offer_arr.list">
                                        <el-table
                                            :data="scope.row.meeting_offer_arr.list"
                                            border
                                            size="mini"
                                            style="width:100%"
                                            :header-cell-style="{background:'#f5f7fa'}"
                                            max-height="180"
                                        >
                                            <el-table-column label="开会日期"  align="center" width="150">
                                                <template slot-scope="scope">
                                                    {{scope.row.date| formatTimestamp(2)}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="时间"  align="center">
                                                <template slot-scope="scope">
                                                    {{scope.row.timeslot| formatVar('TimeSlots')}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="会议室"  align="center">
                                                <template slot-scope="scope">
                                                    <div  class="cursor-pointer" :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')">
                                                        {{scope.row.offer_title}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="价格(元)"  align="center">
                                                <template slot-scope="scope">
                                                    {{scope.row.offer_price | formatMoney}}
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </template>
                            </div>
                            <!--会议室报价-->
                            <!--其他-->
                            <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                header-align="center"
                label="操作"
                v-if="!isAdmin"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="informUser(scope.row)" type="primary" size="small"  style="margin: 0 auto; display: block;">成交订单</el-button>
                </template>
                </el-table-column>
            </el-table>
        </template>
        <!--暂无报价-->
        <template v-else>
            <div class="no-data">
                <img class="no-data-img" src="/images/order/icon_21.png" alt="">
                <div class="no-data-text">
                    <p class="titles">抱歉，暂时没有酒店报价信息。</p>
                    <p class="desc">请耐心等待片刻</p>
                </div>  
            </div>
        </template>
        <!--成交订单提示框-->
        <el-dialog 
        :visible.sync="dialogVisible" 
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :z-index="5"
        top="30vh" 
        >
        <div>建议联系酒店进行确认后再成交订单</div>
        <!-- <div>成交酒店：{{ dialogFormData.hotel_title }}</div> -->
        <div class="mt-1">报 价 人：<span class="red">{{ dialogFormData.offer_name }}</span></div>
        <div class="mt-1">手 机 号：<span class="red">{{ dialogFormData.offer_mobile }}</span></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">未确认</el-button>
            <el-button @click="orderExecuted" type="primary">已确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions,mapState,mapGetters} from 'vuex'
export default {
  name: 'OrderQuotation',
  components: {},
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    quotationList: {
      type: Object,
      default: () => ({
        count:0,
        list:[]
      })
    },
  },
  data() {
    return {
        options: [
            {
                value: '1',
                label: '全部报价'
                }, {
                value: '2',
                label: '只显示报价酒店'
                }, {
                value: '3',
                label: '价格由低到高'
                }, {
                value: '4',
                label: '价格由高到低'
            },
        ],
        hotelList: [], // 酒店列表
        sort: '2',  
        //酒店报价列表
        fundsForm:[
          {name:'酒店名称',prop:'hotel_title',minWidth:200,pattern:'title'},
          {name:'联系人',prop:'offer_name',Width:80,center:true},
          {name:'手机号',prop:'offer_mobile',Width:150,center:true},
          {name:'报价时间',prop:'offer_time',center:true,width:170,pattern:'time'},
          {name:'报价信息',prop:'room_offer_arr',center:true,minWidth:350,pattern:'room_offer_arr'},
        ],
        dialogVisible: false, //成交订单提示框
        dialogFormData: {},  //成交订单酒店
    };
  },
  computed: {
        ...mapGetters(['isAdmin']),
        ...mapState(['RoomMeetDetail']),
  },
  watch: {
    quotationList: {
      handler(newVal, oldVal) {
        // 判断数组里是否有报价酒店
        const hasType1 = newVal.list.some(item => item.offer_type === 1);
        if(!hasType1){this.sort='1'}
        this.combineTay()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
      ...mapActions(['ensureCheckIn','getRoomDetail','getMeetDetail']),
    // 数组扁平化：日期拆分多条房型行
    flatOfferTable(list) {
        const res = []
        list=list.list;
        if (!Array.isArray(list)) return res
        list.forEach(item => {
            if (!Array.isArray(item.offer_info)) return
            item.offer_info.forEach(offer => {
            res.push({ date: item.date, ...offer })
            })
        })
        this.spanArr = this.computeDateSpan(res)
        return res
    },
    // 计算合并数组
    computeDateSpan(tableList) {
        const spanArr = []
        let pos = 0
        tableList.forEach((row, idx) => {
            if (idx === 0) {
            spanArr.push(1)
            pos = 0
            } else {
            if (row.date === tableList[idx - 1].date) {
                spanArr[pos] += 1
                spanArr.push(0)
            } else {
                spanArr.push(1)
                pos = idx
            }
            }
        })
        return spanArr
    },
    objectSpanMethod({ columnIndex, rowIndex }) {
      if (columnIndex === 0) {
        const r = this.spanArr[rowIndex]
        return {
          rowspan: r,
          colspan: r > 0 ? 1 : 0
        }
      }
      // 其他列不合并返回默认
      return { rowspan: 1, colspan: 1 }
    },
    //综合排序
    combineTay(e){
        let list= [...(this.quotationList.list || [])];
        let id=this.sort;
        switch (id) {
            //只显示报价信息
            case '2':
                list=list.filter(a =>a.offer_type==1)
            break;
            //价格由低到高
            case '3':
                list=list.filter(a =>a.offer_type==1);
                list=list.sort((a, b) => {
                    return  a.offer_price - b.offer_price
                })
                break;
            //价格由高到低
            case '4':
                list=list.filter(a =>a.offer_type==1);
                list=list.sort((a, b) => {
                    return  b.offer_price - a.offer_price
                })
            break;
        }
        if(this.orderDetail.room_need_arr.mode==0){
            console.log(list,'房间报价');
             //获取报价信息的一个最低一个最高价
            list.forEach(item => {
                //房间报价最低最高价
                if(item.room_offer_arr.list){
                    let offer_info=[];
                    item.room_offer_arr.list.forEach(room => {
                            console.log(room,132);
                            offer_info.push({...room});
                    })
                    item.room_minPrice=Math.min(...offer_info.map(a => a.offer_price));
                    item.room_maxPrice=Math.max(...offer_info.map(a => a.offer_price));
                };
                //会议室最低最高价
                if(item.meeting_offer_arr.list){
                    item.meeting_minPrice=Math.min(...item.meeting_offer_arr.list.map(a => a.offer_price));
                    item.meeting_maxPrice=Math.max(...item.meeting_offer_arr.list.map(a => a.offer_price));
                }
            });

        }else{
            //获取报价信息的一个最低一个最高价
            list.forEach(item => {
                //房间报价最低最高价
                if(item.room_offer_arr.list){;
                    let offer_info=[];
                    item.room_offer_arr.list.forEach(room => {
                            offer_info.push(...room.offer_info);
                    })
                    item.room_minPrice=Math.min(...offer_info.map(a => a.offer_price));
                    item.room_maxPrice=Math.max(...offer_info.map(a => a.offer_price));
                };
                //会议室最低最高价
                if(item.meeting_offer_arr.list){
                    item.meeting_minPrice=Math.min(...item.meeting_offer_arr.list.map(a => a.offer_price));
                    item.meeting_maxPrice=Math.max(...item.meeting_offer_arr.list.map(a => a.offer_price));
                }
            });
        }
        this.hotelList=list;
    },
    //点击成交订单
    informUser(e){
        this.dialogFormData=e;
        this.dialogVisible = true;
    },
    //订单成交
    orderExecuted(){
        this.ensureCheckIn({
            oid: this.orderDetail.oid,
            hoid: this.dialogFormData.hoid,
            successFun:()=>{
                this.$message({
                    message: '订单成交成功',
                    type: 'success'
                })
                this.dialogVisible = false;
                this.$emit('getorderDetail');
            }
        })
    },
    //地图报价跳转
    goForDetail(e){
        e=this.hotelList;
        localStorage.setItem('Lawyer',JSON.stringify(e))
        let routeUrl = this.$router.resolve({
            name: 'OfferMapPage',
        });
        window.open(routeUrl.href);
    },
    //展示房型、会议室图片
    async showRoomImgs(item,type) {
      if(item==0) return;
      let data = {
        type:3,
        id:item
      }
      switch (type) {
        case 'room':
          await this.getRoomDetail(data);
          break;
        case 'meet':
          await this.getMeetDetail(data);
          break;
      }
      if(this.RoomMeetDetail!=''){
        this._CarouselView({
          currentImg: 0,
          picArray: this.RoomMeetDetail.pic
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>

    /******************酒店报价*******************/
    .OrderHousing-title{
        font-weight: bold;
        font-size: 16px;
    }
    .hotel-img{
        width: 64px;
        height: 64px;
    }
    .hotel-quotation{
        width: 64%;
        padding: 16px 2%;
        background-color: #fff;
        border-radius: 6px;
    }
    .hotel-quotation-head{
        display: flex;
        line-height: 30px;
        p{
            margin-right: 10px;
        }   
    }
    .sort{
        display: flex;
        margin-left: auto;
    }
    .hotel-map{
        margin-left: 10px;
        font-size: 12px;
        line-height: 30px;
        padding: 0 16px;
        border-radius: 4px;
        background-color: var(--smtc-color-primary);
        color: #fff;
        cursor: pointer;
    }
    .hotel-quotation-title{
        display: flex;
         background-color: #f2f7fe;
        margin-top: 18px;
        li{
            width: 50%;
            text-align: center;
                        border: 1px #eee solid;
            padding: 6px 10px;
           
        }
    }
    .hotel-quotation-list{
        margin-top: 20px;
    }
    .name{
        display: flex;
        img{
            width: 80px;
            height: 80px;
        }
    }
    .hotel-title{
        display: flex;
    }
    .hotel-title-content{
        margin-left: 10px;
        .title{

            font-weight: bold;  
            font-size: 16px;

            align-items: center; /* 图片垂直居中 */
        }
        .title img{
            margin-left: 3px;
        }
        .star{
            border: 1px #eee solid;
            width: 80px;
            text-align: center;
            margin-top: 6px;
            padding: 2px 0;
            border-radius: 4px;
            font-size: 12px;
        }
    }
    // .room_offer_arr{
    //     display: flex;
    // }
    // .meeting{
    //     margin-left: 10px;
    // }
    .canAnswer{
        text-align: center;
        width: 100%;
    }
    .no-data{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .no-data-img{
        width: 140px;
    }
    .no-data-text{
        display: flex;
        justify-content: center;
        flex-direction: column;
        .titles{
            font-weight: bold;
        }
        .desc{
            color: #999;
            margin-top: 6px;
        }
    }
</style>
<style>
    .hotel-quotation .el-input,.hotel-quotation .el-input__inner{
        font-size: 12px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        width: 140px;
    }
    .hotel-quotation .el-input__icon{
        line-height: 30px;
    }
</style>

